import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { FormControl, FormLabel, RadioGroup } from '@mui/material';

const GroupRadioButtonForm = ({ control, name, label, defaultValue, rules, children }) => (
    <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue || null}
        render={({ field }) => (
            <FormControl component="fieldset">
                <FormLabel component="legend">{label}</FormLabel>
                <RadioGroup row {...field}>
                    {children}
                </RadioGroup>
            </FormControl>
        )}
    />
);
GroupRadioButtonForm.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.object,
    rules: PropTypes.object.isRequired,
    children: PropTypes.node
};

GroupRadioButtonForm.defaultProps = {
    label: '',
    defaultValue: null
};

export default GroupRadioButtonForm;
